import React, { useEffect, useState } from "react";
import "./Fibermeterselling.css";
import axios from "axios";
import { MdModeEdit } from "react-icons/md";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const Fibermeterselling = () => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;

  const [fiber, setFiber] = useState(null);
  const [editing, setEditing] = useState(false);
  const [editedCost, setEditedCost] = useState("");

  const fetchFiber = async () => {
    try {
      const res = await axios.get(`${apiUrl}get_fibermetersellingcost`);

      if (res.data.length > 0) {
        setFiber(res.data[0]);
      } else {
        // No data found — create default one
        const defaultData = {
          fibermeterselling: "Fiber Meter Selling Cost",
          fibermetersellingcost: 0,
        };

        const createRes = await axios.post(`${apiUrl}add_fibermetersellingcost`, defaultData);
        setFiber(createRes.data);
      }
    } catch (err) {
      console.error("Error fetching fiber", err);
      toast.error("Failed to fetch data");
    }
  };

  useEffect(() => {
    fetchFiber();
  }, []);

  const handleEditClick = () => {
    setEditing(true);
    setEditedCost(fiber.fibermetersellingcost);
  };

  const handleCancelClick = () => {
    setEditing(false);
    setEditedCost("");
  };

  const handleSaveClick = async () => {
    if (!editedCost || isNaN(editedCost) || Number(editedCost) <= 0) {
      toast.error("Please enter a valid fiber meter selling cost");
      return;
    }

    try {
      const res = await axios.put(`${apiUrl}update_fibermetersellingcost/${fiber._id}`, {
        fibermetersellingcost: Number(editedCost),
      });

      setFiber(res.data);
      setEditing(false);
      setEditedCost("");
      toast.success("Fiber cost updated successfully");
    } catch (err) {
      console.error("Error updating fiber cost", err);
      toast.error("Something went wrong while saving");
    }
  };

  if (!fiber) return <p>Loading...</p>;

  return (
    <div className="fiber-table-container">
      <h3 className="text-center">Selling cost</h3>
      <table className="fiber-table">
        <thead className="table-th">
          <tr>
            <th style={{ borderRight: "1px solid white" }}>
             Type
            </th>
            <th style={{ borderRight: "1px solid white" }}>Selling Cost (₹)</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{fiber.fibermeterselling}</td>
            <td>
              {editing ? (
                <input
                  type="number"
                  value={editedCost}
                  onChange={(e) => setEditedCost(e.target.value)}
                  className="cost-input"
                />
              ) : (
                `₹${fiber.fibermetersellingcost}`
              )}
            </td>
            <td>
              {editing ? (
                <>
                  <button className="save-btn" onClick={handleSaveClick}>
                    Save
                  </button>
                  <button className="cancel-btn" onClick={handleCancelClick}>
                    Cancel
                  </button>
                </>
              ) : (
                <span className="edit-icon" onClick={handleEditClick}>
                  <MdModeEdit className="edit-icon" />
                </span>
              )}
            </td>
          </tr>
        </tbody>
      </table>
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};
